import * as React from "react";
import { useEffect, useState } from "react";
import LoginRegister from "@frameworks/web/components/features/LoginFlow/LoginRegisterPage";
import { useSelector } from "react-redux";
import { LoginLogoutDropdown } from "@frameworks/web/components/features/LoginFlow/ClientUser/LoginLogoutDropdown";
import { ILoginFlows } from "@domains/features/LoginFlow/entities/CommonLoginData";
const SignUp = () => {
    // const [isHover, setIsHover] = useState(false);
    // function mouseEnter(e: any) {
    //   const rect = e.target.getBoundingClientRect();
    //   setIsHover(true);
    // }
    // function mouseLeave() {
    //   setIsHover(false);
    // }
    const [show, setShow] = useState(false);
    const [userType, setUserType] = useState();
    const wrapperRef = React.useRef(null);
    const [userID, setUserID] = useState();
    function toggleShow() {
        setShow(!show);
    }
    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShow(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [wrapperRef]);
    const userId = useSelector((state) => state.accountDetailsReducer.userID);
    const { guestId: guestUserID, daysLeft } = useSelector((state) => state.LoginFlow.guestValidateMPIN.data);
    let checkUserData = async () => {
        if (!!userId) {
            setUserType(ILoginFlows.CLIENT);
            setUserID(userId);
        }
        if (!!guestUserID) {
            if (daysLeft > 0) {
                setUserType(ILoginFlows.GUEST);
                setUserID(guestUserID);
            }
        }
    };
    useEffect(() => {
        checkUserData();
    }, [userId, guestUserID]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "signUp nav" },
            React.createElement("ul", { className: "mb-0 ps-3" },
                React.createElement("li", { className: "category" },
                    React.createElement("span", { className: "d-flex align-items-center", onClick: toggleShow },
                        userID ? (React.createElement("div", { className: "signup-block" }, userID.substring(0, 3))) : (React.createElement("i", { className: "edel-icon-user2 pe-2" })),
                        React.createElement("span", { className: "sign-up-text txt-hover" }, userID ? userID : "Login / Sign Up"),
                        !!userID
                            ? show && (React.createElement("div", { ref: wrapperRef },
                                React.createElement(LoginLogoutDropdown, { userName: userID, userType: userType })))
                            : show && (React.createElement("div", { ref: wrapperRef },
                                React.createElement(LoginRegister, null)))))))));
};
export default SignUp;
